import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import BrokersConnection from 'components/BrokersConnection';

import { AccessDeviceActions } from 'state/modules/accessDevice';
import { OrganizationsActions } from 'state/modules/organizations';
import i18n from 'i18n-js';

const AccessDeviceConnections = ({ accessDevice, showLabel = true }) => {
  const dispatch = useDispatch();

  const { fetchingAvailablesBrokers, availablesBrokers, loading } = useSelector(
    (state) => state.organizations
  );

  const addBrokerToAccessDevice = (value) => {
    dispatch(AccessDeviceActions.fetchAddBroker(accessDevice?.id, value));
  };

  const removeBroker = (value) => {
    dispatch(AccessDeviceActions.fetchRemoveBroker(accessDevice?.id, value?.broker_slug));
  };

  useEffect(() => {
    dispatch(
      OrganizationsActions.fetchAvailablesBrokers({ class_slug: 'AD', include_non_primary: true })
    );
  }, []); // eslint-disable-line

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <Container className="h-100">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid size={12}>
            <Typography gutterBottom component="div" align="left">
              <Box fontWeight="500" fontSize={14} pr={4} mt={2} mb={4}>
                {showLabel ? i18n.t('vehicle.select_broker') : ''}
              </Box>
            </Typography>
          </Grid>
          <Grid size={12}>
            <BrokersConnection
              availables={{
                list: [...availablesBrokers],
                loading: fetchingAvailablesBrokers,
              }}
              loading={loading}
              onAddBroker={addBrokerToAccessDevice}
              onRemoveBroker={removeBroker}
              assigned={accessDevice?.brokers || {}}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

AccessDeviceConnections.propTypes = {
  accessDevice: PropTypes.object,
  showLabel: PropTypes.bool,
};

export default AccessDeviceConnections;
